import React from 'react';
import { CheckCircle, Copy, Share2, Instagram } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import './SuccessPage.css';

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const cardId = searchParams.get('cardId');

  const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;
  const shareableLink = `${FRONTEND_URL}/v/${cardId}`;

  const shareText = `Hey! I made something special for you. Check it out here: ${shareableLink}`;

  const copyToClipboard = () => {
    const fallbackCopy = () => {
      const textarea = document.createElement("textarea");
      textarea.value = shareableLink;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand("copy");
        alert("Link copied!");
      } catch {
        alert("Could not copy. Please copy manually.");
      }
      document.body.removeChild(textarea);
    };

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(shareableLink)
        .then(() => alert("Link copied!"))
        .catch(fallbackCopy);
    } else {
      fallbackCopy();
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Your Valentine Card",
          text: shareText,
          url: shareableLink,
        });
      } catch (err) {
        if (err.name !== "AbortError") copyToClipboard();
      }
    } else {
      copyToClipboard();
    }
  };

  return (
    <div className="success-container">
      <div className="success-header">
        <div className="success-icon-wrapper">
          <CheckCircle className="success-icon" size={48} />
        </div>

        <h1 className="success-title">
          You're all <span className="title-accent">set!</span>
        </h1>

        <p className="success-subtitle">
          Your magical link is ready.
        </p>
      </div>

      <div className="success-card">
        <div className="success-card-body">

          {/* Instagram follow – visible before link */}
          <div className="instagram-follow-top">
            <p className="ig-top-text">
              Made this with ❤️  
              <br />
              Help me out by following me on Instagram
            </p>

            <a
              href="https://instagram.com/iam.sparshverma"
              target="_blank"
              rel="noopener noreferrer"
              className="ig-top-link"
            >
              <Instagram size={16} />
              @iam.sparshverma
            </a>
          </div>

          <div className="link-box">
            <code className="link-text">{shareableLink}</code>
            <button
              onClick={copyToClipboard}
              className="copy-btn"
              title="Copy Link"
            >
              <Copy size={18} />
            </button>
          </div>

          <button onClick={handleShare} className="share-btn">
            <Share2 size={20} />
            Share Link
          </button>
        </div>

        <div className="success-card-footer">
          <p>✨ This link is unique and will never expire</p>
        </div>
      </div>

      <footer className="success-footer">
        <strong>⚠️ Save this link now! </strong>
        For your privacy, we do not store personal data.
        If you lose this link, we cannot recover it for you.
      </footer>
    </div>
  );
};

export default SuccessPage;
